module.exports = __webpack_public_path__ + "static/media/han_fla_cut.a4b45d8b.png";